export default "__VITE_ASSET__Bc5IBz6V__"